// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageView {
    width: 150px;
    height: 150px;
    border-radius: 10%;
}

.buttonDivImage {
    margin-top: 30px;
    padding: auto;
}


.marginLeft20 {
    margin-left: 20px;
}

.oldAvatar {
    margin: 15px 15px 0 0;
    position: relative;
}

.updatedImages {
    display: flex;
    flex-direction: row;
    margin: 15px 0 0 0;
}

.profileImages {
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/tabs/image/View1.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".imageView {\n    width: 150px;\n    height: 150px;\n    border-radius: 10%;\n}\n\n.buttonDivImage {\n    margin-top: 30px;\n    padding: auto;\n}\n\n\n.marginLeft20 {\n    margin-left: 20px;\n}\n\n.oldAvatar {\n    margin: 15px 15px 0 0;\n    position: relative;\n}\n\n.updatedImages {\n    display: flex;\n    flex-direction: row;\n    margin: 15px 0 0 0;\n}\n\n.profileImages {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
